<template>
  <el-dialog
    title="Выставить счет"
    :visible="visible"
    custom-class="el-dialog--small"
    @update:visible="updateVisible">
    <div>Текущий ежемесячный платеж: {{ monthlyPayment }}</div>
    <div class="divider" />
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-position="top"
      @submit.native.prevent="onSubmit">
      <el-form-item label="Период оплаты" prop="period">
        <el-select v-model="formData.period" clearable>
          <el-option
            v-for="bill in bills" :key="bill.id" :label="bill.name"
            :value="bill.id" />
        </el-select>
      </el-form-item>
      <div class="divider" />
      <div class="flex-x-center">
        <el-button
          :loading="$mip('makeBill')"
          type="primary"
          native-type="submit"
          size="medium">
          Выставить
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      visible: Boolean
    },

    data() {
      return {
        bills: [],
        formData: {
          period: ''
        },
        rules: {
          period: [
            { required: true, message: 'Пожалуйста, укажите период', trigger: 'change' }
          ]
        }
      }
    },

    computed: {
      monthlyPayment() {
        return this.$store.state.user.accInfo.monthlyPayment
      }
    },

    async created() {
      this.bills = (await this.$http.getAvailableBills()).data
    },

    methods: {
      onSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$http.makeBill(this.formData.period)
              .then(() => {
                this.$emit('update-list')
                this.updateVisible(false)
                this.formData.period = ''
                this.$refs.form.resetFields()
                this.$notify({
                  title: 'Счет выставлен',
                  message: 'Выставленный счет будет находиться в разделе "Счета"',
                  type: 'success'
                })
              })
          } else {
            console.error('Error: form validation')
            return false
          }
        })
      },

      updateVisible(val) {
        this.$emit('update:visible', val)
      }
    }
  }
</script>